import { CONTACT_US_URL } from "utils/constants";
import { getCurrentURL, showToast } from "utils/helpers";
import { logErrorIfDebug } from "utils/logging";

export const openUrlInNewTab = (url: string): void => {
	window.open(url, "_blank", "noopener,noreferrer");
};

export const openContactUsPage = (): void => {
	window.open(CONTACT_US_URL, "_blank");
};

export const getCurrentCompanyId = (): number => {
	const url = getCurrentURL();
	const match = url.match(/\/(account|company)\/(\d+)/);
	return match ? parseInt(match[2], 10) : null;
};

export const getDashboardUrl = (userId: number, companyId?: number): string => {
	let currentCompany = companyId;
	if (!currentCompany) {
		currentCompany = getCurrentCompanyId();
	}

	let fullURL = process.env.REACT_APP_APP_URL;
	return `${fullURL}/account/${companyId}/dashboard/${userId}`;
};

export const getProjectUrl = (
	companyId: number,
	projectId: number,
	projectName: string
): string => {
	let fullURL = process.env.REACT_APP_APP_URL;
	return `${fullURL}/account/${companyId}/projects/${projectId}/${getSlug(projectName)}`;
};

export const getRfxUrl = (
	companyId: number,
	rfxId: number,
	rfxName: string
): string => {
	const slug = getSlug(rfxName);
	let fullURL = process.env.REACT_APP_APP_URL;
	return `${fullURL}/account/${companyId}/rfx/${rfxId}/${slug}/all`;
};

export const getSlug = (name: string, defaultIfEmpty?: string): string => {
	if (!name) {
		return defaultIfEmpty ?? "%20";
	}
	return encodeURIComponent(name.replace(/ /g, "-")?.toLowerCase());
};

export const reverseSlug = (slug: string): string => {
	if (!slug) {
		return "";
	}
	return decodeURIComponent(decodeURIComponent(slug).replace(/-/g, " "));
};

export const downloadFileNoPopup = (
	url: string,
	filename?: string,
	newWindow: boolean = true
): void => {
	try {
		// Extract filename from URL
		const urlParts = url.split("/");
		const downloadFileName =
			filename ?? urlParts[urlParts.length - 1].split("?")[0]; // remove query params

		const a = document.createElement("a");
		a.href = url;
		a.target = newWindow ? "_blank" : "";
		a.download = downloadFileName; // forces download
		a.click();
	} catch (error) {
		logErrorIfDebug(`Error downloading file: ${url}`, error);
		showToast("Error downloading file, please try again.", "error");
	}
};

export const replacementSlug = (
	text: string,
	replacement: string = "-"
): string => {
	if (!text) {
		return "";
	}

	return text
		.normalize("NFD") // decompose accented characters
		.replace(/[\u0300-\u036f]/g, "") // remove diacritics
		.toLowerCase() // lowercase
		.replace(/[^a-z0-9]+/g, replacement) // replace non-alphanum with replacement
		.replace(new RegExp(`^${replacement}+|${replacement}+$`, "g"), ""); // trim edges
};

export const replaceNewInUrlWithId = (newId: number) => {
	const currentUrl = window.location.href; // full URL

	// Replace "/new" at the end with the new ID
	const newUrl = currentUrl.replace(/\/new$/, `/${newId}`);

	window.history.replaceState(null, "", newUrl);
};
